import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {Link} from "react-router-dom";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {CreateNewFolder} from "@mui/icons-material";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
            }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
            }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function CategoryMenu()
{
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                id="demo-customized-button"
                sx={{ mr: 2, ml: 2, width: '90%' }}
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                Admin
            </Button>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                    }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {/*<MenuItem onClick={handleClose} component={Link} to={"admin/list/courses"} disableRipple>*/}
                {/*    <FileUploadIcon />*/}
                {/*    Kurzus Manager*/}
                {/*</MenuItem>*/}
                <MenuItem onClick={handleClose} component={Link} to={"addUser"} disableRipple>
                    Új Felhasználó
                </MenuItem>
                <MenuItem onClick={handleClose} component={Link} to={"admin/list/users"} disableRipple>
                    Felhasználók
                </MenuItem>
                <MenuItem onClick={handleClose} component={Link} to={"addEvent"} disableRipple>
                    Új Hír
                </MenuItem>
                <MenuItem onClick={handleClose} component={Link} to={"listEvents"} disableRipple>
                    Hírek
                </MenuItem>
            </StyledMenu>
        </div>
    );
}
